/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from 'Constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getDashboardDetails: ( {startDate , endDate} ) => {
    return axios.get(API_ENDPOINTS.DASHBOARD, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        "x-tenant-slug": "default"
      },
      params: {
        startDate, // Query parameter for start date
        endDate,   // Query parameter for end date
      },
    });
  },
  getAdminDashboardDetails: (params = {}) => {
    return axios.get(API_ENDPOINTS.DASHBOARD_ADMIN, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        "x-tenant-slug": "default"
      },
      params,
    });
  },
}
